<template>
  <section>
    <div class="columns">
      <div class="column">
        <div class="container mt-3">
          <div class="box">
            <section class="hero is-primary welcome is-small mb-4">
              <div class="hero-body">
                <div class="container">
                  <h1 class="title">
                    Exportación de Estadísticas Proceso {{ year
                    }}<i class="fas fa-file-excel ml-2"></i>
                  </h1>
                </div>
              </div>
            </section>
            <div>
              <section v-if="is_principal" class="info-tiles">
                <div class="tile is-ancestor has-text-centered">
                  <div class="tile is-parent">
                    <article class="tile is-child box">
                      <a
                        @click="
                          downloadData(
                            `/performances/summary_state_performances/${year}.xlsx`
                          )
                        "
                      >
                        <p class="subtitle is-4">
                          <span class="icon-text">
                            <span class="icon is-medium">
                              <i class="fas fa-tasks"></i>
                            </span>
                            <span
                              >Descargar resumen del estado de los
                              convenios</span
                            >
                          </span>
                        </p>
                      </a>
                    </article>
                  </div>
                  <div class="tile is-parent">
                    <article class="tile is-child box">
                      <a
                        @click="
                          downloadData(
                            `/performances/summary_hours_performance/${year}.xlsx`
                          )
                        "
                      >
                        <p class="subtitle is-4">
                          <span class="icon-text">
                            <span class="icon is-medium">
                              <i class="fas fa-business-time"></i>
                            </span>
                            <span
                              >Descargar resumen de horas de actividades</span
                            >
                          </span>
                        </p>
                      </a>
                    </article>
                  </div>
                </div>
                <div class="tile is-ancestor has-text-centered">
                  <div class="tile is-parent">
                    <article class="tile is-child box">
                      <a
                        @click="
                          downloadData(
                            `/performances/indicator_state_performances/${year}.xlsx`
                          )
                        "
                      >
                        <p class="subtitle is-4">
                          <span class="icon-text">
                            <span class="icon is-medium">
                              <i class="fas fa-list-ol"></i>
                            </span>
                            <span
                              >Descargar indicadores de estados de los
                              convenios</span
                            >
                          </span>
                        </p>
                      </a>
                    </article>
                  </div>
                </div>
              </section>
              <section v-else class="info-tiles">
                <div class="tile is-ancestor has-text-centered">
                  <div class="tile is-parent">
                    <article class="tile is-child box">
                      <a
                        @click="
                          downloadData(
                            `/performances/summary_faculty_state_performances/${year}.xlsx`
                          )
                        "
                      >
                        <p class="subtitle is-4">
                          <span class="icon-text">
                            <span class="icon is-medium">
                              <i class="fas fa-tasks"></i>
                            </span>
                            <span
                              >Descargar resumen del estado de los
                              convenios</span
                            >
                          </span>
                        </p>
                      </a>
                    </article>
                  </div>
                  <div class="tile is-parent">
                    <article class="tile is-child box">
                      <a
                        @click="
                          downloadData(
                            `/performances/summary_faculty_hours_performance/${year}.xlsx`
                          )
                        "
                      >
                        <p class="subtitle is-4">
                          <span class="icon-text">
                            <span class="icon is-medium">
                              <i class="fas fa-business-time"></i>
                            </span>
                            <span
                              >Descargar resumen de horas de actividades</span
                            >
                          </span>
                        </p>
                      </a>
                    </article>
                  </div>
                </div>
                <div class="tile is-ancestor has-text-centered">
                  <div class="tile is-parent">
                    <article class="tile is-child box">
                      <a
                        @click="
                          downloadData(
                            `/performances/indicator_faculty_state_performances/${year}.xlsx`
                          )
                        "
                      >
                        <p class="subtitle is-4">
                          <span class="icon-text">
                            <span class="icon is-medium">
                              <i class="fas fa-list-ol"></i>
                            </span>
                            <span
                              >Descargar indicadores de estados de los
                              convenios</span
                            >
                          </span>
                        </p>
                      </a>
                    </article>
                  </div>
                  <div class="tile is-parent">
                    <article class="tile is-child box">
                      <a
                        @click="
                          downloadData(
                            `/performances/indicator_faculty_average_hours/${year}.xlsx`
                          )
                        "
                      >
                        <p class="subtitle is-4">
                          <span class="icon-text">
                            <span class="icon is-medium">
                              <i class="fas fa-bullseye"></i>
                            </span>
                            <span
                              >Descargar horas promedios por departamento</span
                            >
                          </span>
                        </p>
                      </a>
                    </article>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import axios from "axios";
export default {
  props: ["unit", "year", "is_principal"],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    downloadData(url) {
      this.isLoading = true;
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          this.isLoading = false;
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Intenta recuperar el nombre del archivo desde el header
          let fileName = "archivo.xlsx";
          const disposition = response.headers["content-disposition"];
          if (disposition && disposition.includes("filename=")) {
            const match = disposition.match(
              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            );
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
          }

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          vm.$buefy.dialog.alert({
            title: "Error",
            message: "Error al descargar los datos.",
            confirmText: "OK",
            type: "is-danger",
          });
        });
    },
  },
};
</script>
